/**
 * parse date string in the format HH:MM:SS
 */

export const parseTime = (time: string, date = new Date()): Date | null => {
  const match = time.match(/(\d{2}):(\d{2}):(\d{2})/);
  if (match) {
    const hh = parseInt(match[1]);
    const mm = parseInt(match[2]);
    const ss = parseInt(match[3]);
    date.setHours(hh, mm, ss, 0);
    return date;
  }
  return null;
};
